var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "select-content" }, [
    _c("h3", { staticClass: "text-align-center" }, [
      _vm._v("Pagos en confirmación"),
    ]),
    _c(
      "div",
      { staticClass: "related-transactions" },
      _vm._l(_vm.relatedTransactions, function (transaction, i) {
        return _c(
          "div",
          {
            key: transaction._id,
            staticClass:
              "card-item shadowless pending-transaction-item transition-slow",
            class:
              _vm.extendedTransaction._id === transaction._id ? "extended" : "",
            attrs: { id: `related-transaction-${i}` },
          },
          [
            _c("div", { staticClass: "transaction-head" }, [
              _c(
                "div",
                { staticClass: "transaction-head-info payment-title" },
                [
                  _c("span", { staticClass: "header-payment-title" }, [
                    _vm._v("Pago " + _vm._s(i + 1)),
                  ]),
                ]
              ),
              _c("div", { staticClass: "transaction-head-info payment-date" }, [
                _c(
                  "span",
                  {
                    staticClass: "header-title",
                    class:
                      _vm.extendedTransaction._id !== transaction._id
                        ? "hidden"
                        : "",
                  },
                  [_vm._v(" Fecha: ")]
                ),
                _c("span", { staticClass: "header-value" }, [
                  _vm._v(_vm._s(_vm.dateFormat(transaction.createdAt))),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "transaction-head-info payment-provider",
                  class:
                    _vm.extendedTransaction._id !== transaction._id
                      ? "hidden"
                      : "",
                },
                [
                  _c("span", { staticClass: "header-title" }, [
                    _vm._v("Medio de pago:"),
                  ]),
                  _c("span", { staticClass: "header-value" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.paymentProviders.find(
                            (x) => x.slug === transaction.provider
                          ).name
                        ) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "transaction-head-info payment-id",
                  class:
                    _vm.extendedTransaction._id !== transaction._id
                      ? "hidden"
                      : "",
                },
                [
                  _c("span", { staticClass: "header-title" }, [
                    _vm._v("Id de transacción:"),
                  ]),
                  _c("span", { staticClass: "header-value" }, [
                    _vm._v(_vm._s(transaction._id)),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "transaction-head-info payment-details" },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        id: `extend-related-transaction-${i}`,
                        href: "#",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showExtendedTransaction(transaction)
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "fa",
                        class:
                          _vm.extendedTransaction._id === transaction._id
                            ? "fa-minus-circle"
                            : "fa-plus-circle",
                      }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm.extendedTransaction._id === transaction._id
              ? _c("RelatedTransaction", {
                  attrs: {
                    transaction: _vm.extendedTransaction,
                    "payment-providers": _vm.paymentProviders,
                    "display-cancel-button": _vm.cancelRelatedTransactionButton,
                  },
                  on: {
                    "open-cancel-transaction-modal": function ($event) {
                      return _vm.$emit("open-cancel-transaction-modal", $event)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }